import PropTypes from 'prop-types'

export const CopyCodesIcon = ({title = null}) => (
  <svg
    aria-hidden={!title}
    fill='none'
    height='20px'
    role={title ? 'img' : null}
    viewBox='0 0 16 18'
    width='20px'
    xmlns='http://www.w3.org/2000/svg'>
    {title ? <title>{title}</title> : null}
    <path
      d='M5.125 8.875H8.25M5.125 11.375H8.25M5.125 13.875H8.25M10.75 14.5H12.625C13.1223 14.5 13.5992 14.3025 13.9508 13.9508C14.3025 13.5992 14.5 13.1223 14.5 12.625V3.965C14.5 3.01917 13.7958 2.21667 12.8533 2.13833C12.5417 2.11249 12.2297 2.09026 11.9175 2.07167M11.9175 2.07167C11.9728 2.2509 12.0001 2.43743 12 2.625C12 2.79076 11.9342 2.94973 11.8169 3.06694C11.6997 3.18415 11.5408 3.25 11.375 3.25H7.625C7.28 3.25 7 2.97 7 2.625C7 2.4325 7.02917 2.24667 7.08333 2.07167M11.9175 2.07167C11.6817 1.30667 10.9683 0.75 10.125 0.75H8.875C8.47437 0.750094 8.08429 0.878454 7.76188 1.11628C7.43948 1.35411 7.20169 1.68892 7.08333 2.07167M7.08333 2.07167C6.77 2.09083 6.45833 2.11333 6.14667 2.13833C5.20417 2.21667 4.5 3.01917 4.5 3.965V5.75M4.5 5.75H1.6875C1.17 5.75 0.75 6.17 0.75 6.6875V16.0625C0.75 16.58 1.17 17 1.6875 17H9.8125C10.33 17 10.75 16.58 10.75 16.0625V6.6875C10.75 6.17 10.33 5.75 9.8125 5.75H4.5ZM3.25 8.875H3.25667V8.88167H3.25V8.875ZM3.25 11.375H3.25667V11.3817H3.25V11.375ZM3.25 13.875H3.25667V13.8817H3.25V13.875Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

CopyCodesIcon.propTypes = {title: PropTypes.string}
